/**
 * Formats a number as Ghanaian Cedis with thousands separators.
 * e.g. formatCurrency(12345.6) → "GH₵ 12,345.60"
 */
export const formatCurrency = (amount: number | string, decimals = 2): string => {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return `GH₵ 0.${'0'.repeat(decimals)}`;
  return `GH₵ ${num.toLocaleString('en-GH', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
};
